import $ from 'jquery';

// npm install slick-carousel --save-dev
import 'slick-carousel';

class SlickCarousel {
    constructor() {
        this.$window = $(window);

        $('.js-carousel').slick({
            dots: false,
            arrows: true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: $('.c-image-slider__nav-left'),
            nextArrow: $('.c-image-slider__nav-right'),
        });
    }
}

export default SlickCarousel;
